module.exports = __webpack_public_path__ + "img/hot.5494d87.svg";